module.exports = __webpack_public_path__ + "static/media/adone2.f01cc036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adone2.jpg
// module id = 242
// module chunks = 0